var map = {
	"./Alchimeia_island_treasure.png": "9b10",
	"./Chance_island_treasure.png": "a72d",
	"./Fabella_island_treasure.png": "5937",
	"./Judgement_island_treasure.png": "5919",
	"./Lumina_island_treasure.png": "5113",
	"./Morbida_island_treasure.png": "58f0",
	"./Oracle_island_treasure.png": "1d1f",
	"./Solace_island_treasure.png": "3416",
	"./Sylva_island_treasure.png": "c2de",
	"./Temperus_island_treasure.png": "d574",
	"./Veritas_island_treasure.png": "1769"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b51e";